<template>
  <el-collapse v-model="palletReceipt.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="pallet-receipt-search-section" id="pallet-receipt-search-section">
      <el-form
        id="pallet-receipt-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
            <el-col :span="8">
            <el-form-item :label="$t('palletReceipt.warehouse')">
               <el-input
                v-model="palletReceipt.warehouseCode"
                ref="filter-layout-template"
                disabled
                class="inline-input"
                id="search-form-warehouse"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('palletReceipt.dayOfServiceFrom')" prop="dayOfServiceFrom">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                @change="handleChangeDate"
                v-model="searchForm.dayOfServiceFrom"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                id="searchForm-date-of-service-from"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('palletReceipt.dayOfServiceTo')" prop="dayOfServiceTo">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                @change="handleChangeDate"
                v-model="searchForm.dayOfServiceTo"
                format="MM/dd/yyyy"
                clearable
                type="date"
                id="searchForm-date-of-service-to"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('common.search')"
              placement="top-start"
            >
              <el-button
                id="form-search-button"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
                class="button-action-default"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import { PALLET_RECEIPT_SEARCH } from '@/store/actions';

export default {
  name: 'SearchFilters',
  computed: {
    ...mapGetters(['palletReceipt'])
  },
  data() {
    return {
      searchForm: {
        dayOfServiceFrom: new Date(),
        dayOfServiceTo: null
      },
      activeCollapsibleName: ['pallet-receipt-search-section'],
      urlShipperAutocomplete: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      urlConsigneeAutocomlplete: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(PALLET_RECEIPT_SEARCH, this.searchForm);
    },
    handleChangeDate() {
      this.handleSearch();
    }
  }
};
</script>
